import home from "./en/home";
import chat from "./en/chat";
import flowWork from "./en/flowWork";
import console from "./en/console";
import request from "./en/request";
import knowledgeBase from "./en/knowledgeBase";
import database from "./en/database";
import plugins from "./en/plugins";
import integrations from "./en/integrations";
import client from "./en/client";
import custom from "./en/custom";
import chatManage from "./en/chatManage";
import myCenter from "./en/myCenter";
import echarts from "./en/echarts";
import teamSpace from "./en/teamSpace";
import templateCenter from "./en/templateCenter";
import workFlow from "./en/workFlow";
import router18 from "./en/router18";
import privige from "./en/privige";
import linkAiForm from "./en/linkAiForm";
export default {
  ...home,
  ...chat,
  ...flowWork,
  ...console,
  ...request,
  ...knowledgeBase,
  ...database,
  ...plugins,
  ...integrations,
  ...client,
  ...custom,
  ...chatManage,
  ...myCenter,
  ...echarts,
  ...teamSpace,
  ...templateCenter,
  ...workFlow,
  ...router18,
  ...privige,
  ...linkAiForm,
};
